module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/035-554b2fe1b69f7671a71f834c08115046.jpg";